exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.adp-filter-input--no-result {\n  padding-left: 24px;\n  margin-top: 20px;\n  font-size: 16px;\n}\n.notifications-error {\n  margin-left: 25px;\n  margin-right: 25px;\n  margin-top: 25px;\n}\n", ""]);

// exports
